











































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
// @ts-ignore: Unreachable code error
import Qrcode from '@chenfengyuan/vue-qrcode/src/index'
// @ts-ignore: Unreachable code error
import VueBarcode from '@xkeshi/vue-barcode'
import moment from 'moment'
import HTTP from '@/plugins/axios'
import { BoletoDTO } from '@/interfaces/Boleto.interface'
import { VentaDTO } from '@/interfaces/Ventas.interface';
moment.locale('es-MX')

@Component
export default class PrintCorte extends Vue {
  @Prop({ type: Object })
  private printInfo!: any
  @Prop({ type: Boolean })
  private printNow!: boolean

  private name: string = 'PrintCorte'
  private typeInfo: string = null
  private isCopy: boolean = false
  private isCopyMSG: string = 'ESTO ES UNA COPIA'

  @Watch('printInfo')
  private watchPrintInfo (v: any) {
    console.log('watchPrintInfo :: ', v)
    this.isCopy = false
    if (v) {
      setTimeout(() => {
        // @ts-ignore: Unreachable code error
        this.$htmlToPaper('printMeCorte')
      }, 100)
      console.log('Finish Print')
    }
  }

  private totalBoletos (boletos: BoletoDTO[]) {
    let res = 0

    boletos.forEach((bole: any) => {
      if (bole.venta.isCancel === null) {
        res = parseFloat(res.toString()) + parseFloat(bole.cost.toString())
      }
    })
    return res.toFixed(2)
  }

  private totalBoletosCancelados (boletos: BoletoDTO[]) {
    let res = 0

    boletos.forEach((bole: any) => {
      if (bole.venta.isCancel !== null) {
        res = parseFloat(res.toString()) + parseFloat(bole.cost.toString())
      }
    })
    return res.toFixed(2)
  }

  private totalVentas (venta: any[]) {
    let res = 0

    venta.forEach((vent: any) => {
      if (vent.isCancel === null) {
        res = parseFloat(res.toString()) + parseFloat(vent.amountPay.toString())
      }
    })
    return res.toFixed(2)
  }

  private totalVentasCanceladas (venta: any[]) {
    let res = 0

    venta.forEach((vent: any) => {
      if (vent.isCancel !== null) {
        res = parseFloat(res.toString()) + parseFloat(vent.amountPay.toString())
      }
    })
    return res.toFixed(2)
  }

  private ventasNoCanceladas (items: VentaDTO[]) {
    let res: any[] = []
    items.forEach((item: VentaDTO) => {
      if (item.isCancel === null) {
        res.push(item)
      }
    })
    return res
  }

  private ventasCanceladas (items: VentaDTO[]) {
    let res: any[] = []
    items.forEach((item: VentaDTO) => {
      if (item.isCancel !== null) {
        res.push(item)
      }
    })
    return res
  }

  private agroupBoletoImpresion (boletos: BoletoDTO[]) {
    console.log('agroupBoletoImpresion :: ', boletos)
    let res: any[] = []
    let tipoBoleto: any[] = []
    let found: boolean = false
    boletos.forEach((bole: any) => {
      if (tipoBoleto.length > 0) {
        tipoBoleto.forEach((tipo: any) => {
          if (tipo.name === bole.name) {
            found = true
          }
        })

        if (!found) {
          tipoBoleto.push(bole)
        }
        found = false
      } else {
        tipoBoleto.push(bole)
      }
    })

    console.log('tipoBoleto :: ', tipoBoleto)
    tipoBoleto.forEach((tipo: any) => {
      let data: any = {
        name: tipo.name,
        quantity: 0,
        cost: tipo.cost,
        total: 0
      }
      boletos.forEach((bole: any) => {
        if ((bole.name === tipo.name) && (bole.venta.isCancel === null)) {
          data.quantity = data.quantity + 1
        }
      })
      // @ts-ignore: Unreachable code error
      data.total = parseFloat(data.quantity * data.cost)
      res.push(data)
    })
    // console.log('agroupBoletoImpresion :: res :: ', res)
    return res
  }

  private agroupBoletoImpresionCancelados (boletos: BoletoDTO[]) {
    console.log('agroupBoletoImpresionCancelados :: ', boletos)
    let res: any[] = []
    let tipoBoleto: any[] = []
    let found: boolean = false
    boletos.forEach((bole: any) => {
      if (tipoBoleto.length > 0) {
        tipoBoleto.forEach((tipo: any) => {
          if (tipo.name === bole.name) {
            found = true
          }
        })

        if (!found) {
          tipoBoleto.push(bole)
        }
        found = false
      } else {
        tipoBoleto.push(bole)
      }
    })

    console.log('tipoBoleto :: ', tipoBoleto)
    tipoBoleto.forEach((tipo: any) => {
      let data: any = {
        name: tipo.name,
        quantity: 0,
        cost: tipo.cost,
        total: 0
      }
      boletos.forEach((bole: any) => {
        if ((bole.name === tipo.name) && (bole.venta.isCancel !== null)) {
          data.quantity = data.quantity + 1
        }
      })
      // @ts-ignore: Unreachable code error
      data.total = parseFloat(data.quantity * data.cost)
      res.push(data)
    })
    // console.log('agroupBoletoImpresion :: res :: ', res)
    return res
  }

  private beforeMount () {
    console.log('beforeMount :: ', this.name)
  }
}
